import * as f from "react";
import { isValidElement as z, useLayoutEffect as k, useEffect as h, useRef as O, useCallback as F, useMemo as $, useState as y, useReducer as q } from "react";
import { jsx as v } from "react/jsx-runtime";
var G = Object.defineProperty, J = Object.defineProperties, Q = Object.getOwnPropertyDescriptors, P = Object.getOwnPropertySymbols, j = Object.prototype.hasOwnProperty, B = Object.prototype.propertyIsEnumerable, M = (t, e, n) => e in t ? G(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, u = (t, e) => {
  for (var n in e || (e = {}))
    j.call(e, n) && M(t, n, e[n]);
  if (P)
    for (var n of P(e))
      B.call(e, n) && M(t, n, e[n]);
  return t;
}, p = (t, e) => J(t, Q(e)), Z = (t, e) => {
  var n = {};
  for (var r in t)
    j.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && P)
    for (var r of P(t))
      e.indexOf(r) < 0 && B.call(t, r) && (n[r] = t[r]);
  return n;
}, tt = Object.defineProperty, et = Object.defineProperties, nt = Object.getOwnPropertyDescriptors, R = Object.getOwnPropertySymbols, W = Object.prototype.hasOwnProperty, U = Object.prototype.propertyIsEnumerable, L = (t, e, n) => e in t ? tt(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, X = (t, e) => {
  for (var n in e || (e = {}))
    W.call(e, n) && L(t, n, e[n]);
  if (R)
    for (var n of R(e))
      U.call(e, n) && L(t, n, e[n]);
  return t;
}, rt = (t, e) => et(t, nt(e)), bt = (t, e) => {
  var n = {};
  for (var r in t)
    W.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && R)
    for (var r of R(t))
      e.indexOf(r) < 0 && U.call(t, r) && (n[r] = t[r]);
  return n;
};
function Pt(...t) {
}
function Rt(t, e) {
  if (ot(t)) {
    const n = it(e) ? e() : e;
    return t(n);
  }
  return t;
}
function ot(t) {
  return typeof t == "function";
}
function it(t) {
  return typeof t == "function";
}
function S(t, e) {
  return typeof Object.hasOwn == "function" ? Object.hasOwn(t, e) : Object.prototype.hasOwnProperty.call(t, e);
}
function xt(...t) {
  return (...e) => {
    for (const n of t)
      typeof n == "function" && n(...e);
  };
}
function Ot(t) {
  return t.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
function St(t, e) {
  const n = X({}, t);
  for (const r of e)
    S(n, r) && delete n[r];
  return n;
}
function Ct(t, e) {
  const n = {};
  for (const r of e)
    S(t, r) && (n[r] = t[r]);
  return n;
}
function Nt(t) {
  return t;
}
function Tt(t, e) {
  if (!t)
    throw typeof e != "string" ? new Error("Invariant failed") : new Error(e);
}
function Mt(t) {
  return Object.keys(t);
}
function Lt(t, ...e) {
  const n = typeof t == "function" ? t(...e) : t;
  return n == null ? !1 : !n;
}
function At(t) {
  return t.disabled || t["aria-disabled"] === !0 || t["aria-disabled"] === "true";
}
function It(t) {
  const e = {};
  for (const n in t)
    t[n] !== void 0 && (e[n] = t[n]);
  return e;
}
function Vt(...t) {
  for (const e of t)
    if (e !== void 0) return e;
}
function st(t, e) {
  typeof t == "function" ? t(e) : t && (t.current = e);
}
function ut(t) {
  return !t || !z(t) ? !1 : "ref" in t.props || "ref" in t;
}
function at(t) {
  return ut(t) ? u({}, t.props).ref || t.ref : null;
}
function ct(t, e) {
  const n = u({}, t);
  for (const r in e) {
    if (!S(e, r)) continue;
    if (r === "className") {
      const i = "className";
      n[i] = t[i] ? `${t[i]} ${e[i]}` : e[i];
      continue;
    }
    if (r === "style") {
      const i = "style";
      n[i] = t[i] ? u(u({}, t[i]), e[i]) : e[i];
      continue;
    }
    const o = e[r];
    if (typeof o == "function" && r.startsWith("on")) {
      const i = t[r];
      if (typeof i == "function") {
        n[r] = (...s) => {
          o(...s), i(...s);
        };
        continue;
      }
    }
    n[r] = o;
  }
  return n;
}
var w = ft();
function ft() {
  var t;
  return typeof window < "u" && !!((t = window.document) != null && t.createElement);
}
function _(t) {
  return t ? t.ownerDocument || t : document;
}
function Dt(t) {
  return _(t).defaultView || window;
}
function lt(t, e = !1) {
  const { activeElement: n } = _(t);
  if (!(n != null && n.nodeName))
    return null;
  if (dt(n) && n.contentDocument)
    return lt(
      n.contentDocument.body,
      e
    );
  if (e) {
    const r = n.getAttribute("aria-activedescendant");
    if (r) {
      const o = _(n).getElementById(r);
      if (o)
        return o;
    }
  }
  return n;
}
function x(t, e) {
  return t === e || t.contains(e);
}
function dt(t) {
  return t.tagName === "IFRAME";
}
function Ft(t) {
  const e = t.tagName.toLowerCase();
  return e === "button" ? !0 : e === "input" && t.type ? pt.indexOf(t.type) !== -1 : !1;
}
var pt = [
  "button",
  "color",
  "file",
  "image",
  "reset",
  "submit"
];
function $t(t) {
  if (typeof t.checkVisibility == "function")
    return t.checkVisibility();
  const e = t;
  return e.offsetWidth > 0 || e.offsetHeight > 0 || t.getClientRects().length > 0;
}
function C(t) {
  try {
    const e = t instanceof HTMLInputElement && t.selectionStart !== null, n = t.tagName === "TEXTAREA";
    return e || n || !1;
  } catch {
    return !1;
  }
}
function jt(t) {
  return t.isContentEditable || C(t);
}
function Bt(t) {
  if (C(t))
    return t.value;
  if (t.isContentEditable) {
    const e = _(t).createRange();
    return e.selectNodeContents(t), e.toString();
  }
  return "";
}
function Wt(t) {
  let e = 0, n = 0;
  if (C(t))
    e = t.selectionStart || 0, n = t.selectionEnd || 0;
  else if (t.isContentEditable) {
    const r = _(t).getSelection();
    if (r != null && r.rangeCount && r.anchorNode && x(t, r.anchorNode) && r.focusNode && x(t, r.focusNode)) {
      const o = r.getRangeAt(0), i = o.cloneRange();
      i.selectNodeContents(t), i.setEnd(o.startContainer, o.startOffset), e = i.toString().length, i.setEnd(o.endContainer, o.endOffset), n = i.toString().length;
    }
  }
  return { start: e, end: n };
}
function vt(t, e) {
  const n = ["dialog", "menu", "listbox", "tree", "grid"], r = t == null ? void 0 : t.getAttribute("role");
  return r && n.indexOf(r) !== -1 ? r : e;
}
function Ut(t, e) {
  var n;
  const r = {
    menu: "menuitem",
    listbox: "option",
    tree: "treeitem"
  }, o = vt(t);
  return o && (n = r[o]) != null ? n : e;
}
function gt(t) {
  if (!t) return null;
  const e = (n) => n === "auto" || n === "scroll";
  if (t.clientHeight && t.scrollHeight > t.clientHeight) {
    const { overflowY: n } = getComputedStyle(t);
    if (e(n)) return t;
  } else if (t.clientWidth && t.scrollWidth > t.clientWidth) {
    const { overflowX: n } = getComputedStyle(t);
    if (e(n)) return t;
  }
  return gt(t.parentElement) || document.scrollingElement || document.body;
}
function Xt(t, ...e) {
  /text|search|password|tel|url/i.test(t.type) && t.setSelectionRange(...e);
}
function mt() {
  return w && !!navigator.maxTouchPoints;
}
function H() {
  return w ? /mac|iphone|ipad|ipod/i.test(navigator.platform) : !1;
}
function Ht() {
  return w && H() && /apple/i.test(navigator.vendor);
}
function Kt() {
  return w && /firefox\//i.test(navigator.userAgent);
}
function Yt() {
  return w && navigator.platform.startsWith("Mac") && !mt();
}
function zt(t) {
  return !!(t.currentTarget && !x(t.currentTarget, t.target));
}
function kt(t) {
  return t.target === t.currentTarget;
}
function qt(t) {
  const e = t.currentTarget;
  if (!e) return !1;
  const n = H();
  if (n && !t.metaKey || !n && !t.ctrlKey) return !1;
  const r = e.tagName.toLowerCase();
  return r === "a" || r === "button" && e.type === "submit" || r === "input" && e.type === "submit";
}
function Gt(t) {
  const e = t.currentTarget;
  if (!e) return !1;
  const n = e.tagName.toLowerCase();
  return t.altKey ? n === "a" || n === "button" && e.type === "submit" || n === "input" && e.type === "submit" : !1;
}
function Jt(t, e) {
  const n = new FocusEvent("blur", e), r = t.dispatchEvent(n), o = rt(X({}, e), { bubbles: !0 });
  return t.dispatchEvent(new FocusEvent("focusout", o)), r;
}
function Qt(t, e, n) {
  const r = new KeyboardEvent(e, n);
  return t.dispatchEvent(r);
}
function Zt(t, e) {
  const n = new MouseEvent("click", e);
  return t.dispatchEvent(n);
}
function te(t, e) {
  const n = e || t.currentTarget, r = t.relatedTarget;
  return !r || !x(n, r);
}
function ee(t, e, n, r) {
  const i = ((c) => {
    const d = requestAnimationFrame(c);
    return () => cancelAnimationFrame(d);
  })(() => {
    t.removeEventListener(e, s, !0), n();
  }), s = () => {
    i(), n();
  };
  return t.addEventListener(e, s, { once: !0, capture: !0 }), i;
}
function g(t, e, n, r = window) {
  const o = [];
  try {
    r.document.addEventListener(t, e, n);
    for (const s of Array.from(r.frames))
      o.push(g(t, e, n, s));
  } catch {
  }
  return () => {
    try {
      r.document.removeEventListener(t, e, n);
    } catch {
    }
    for (const s of o)
      s();
  };
}
var N = u({}, f), A = N.useId;
N.useDeferredValue;
var I = N.useInsertionEffect, m = w ? k : h;
function yt(t) {
  const [e] = y(t);
  return e;
}
function ne(t) {
  const e = O(t);
  return m(() => {
    e.current = t;
  }), e;
}
function K(t) {
  const e = O(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  return I ? I(() => {
    e.current = t;
  }) : e.current = t, F((...n) => {
    var r;
    return (r = e.current) == null ? void 0 : r.call(e, ...n);
  }, []);
}
function re(t) {
  const [e, n] = y(null);
  return m(() => {
    if (e == null || !t) return;
    let r = null;
    return t((o) => (r = o, e)), () => {
      t(r);
    };
  }, [e, t]), [e, n];
}
function Y(...t) {
  return $(() => {
    if (t.some(Boolean))
      return (e) => {
        for (const n of t)
          st(n, e);
      };
  }, t);
}
function oe(t) {
  if (A) {
    const r = A();
    return t || r;
  }
  const [e, n] = y(t);
  return m(() => {
    if (t || e) return;
    const r = Math.random().toString(36).substr(2, 6);
    n(`id-${r}`);
  }, [t, e]), t || e;
}
function ie(t, e) {
  const n = (i) => {
    if (typeof i == "string")
      return i;
  }, [r, o] = y(() => n(e));
  return m(() => {
    const i = t && "current" in t ? t.current : t;
    o((i == null ? void 0 : i.tagName.toLowerCase()) || n(e));
  }, [t, e]), r;
}
function se(t, e, n) {
  const r = yt(n), [o, i] = y(r);
  return h(() => {
    const s = t && "current" in t ? t.current : t;
    if (!s) return;
    const c = () => {
      const a = s.getAttribute(e);
      i(a ?? r);
    }, d = new MutationObserver(c);
    return d.observe(s, { attributeFilter: [e] }), c(), () => d.disconnect();
  }, [t, e, r]), o;
}
function ue(t, e) {
  const n = O(!1);
  h(() => {
    if (n.current)
      return t();
    n.current = !0;
  }, e), h(
    () => () => {
      n.current = !1;
    },
    []
  );
}
function ae(t, e) {
  const n = O(!1);
  m(() => {
    if (n.current)
      return t();
    n.current = !0;
  }, e), m(
    () => () => {
      n.current = !1;
    },
    []
  );
}
function ce() {
  return q(() => [], []);
}
function fe(t) {
  return K(
    typeof t == "function" ? t : () => t
  );
}
function le(t, e, n = []) {
  const r = F(
    (o) => (t.wrapElement && (o = t.wrapElement(o)), e(o)),
    [...n, t.wrapElement]
  );
  return p(u({}, t), { wrapElement: r });
}
function de(t = !1, e) {
  const [n, r] = y(null);
  return { portalRef: Y(r, e), portalNode: n, domReady: !t || n };
}
function pe(t, e, n) {
  const r = t.onLoadedMetadataCapture, o = $(() => Object.assign(() => {
  }, p(u({}, r), { [e]: n })), [r, e, n]);
  return [r == null ? void 0 : r[e], { onLoadedMetadataCapture: o }];
}
function ve() {
  return h(() => {
    g("mousemove", Et, !0), g("mousedown", b, !0), g("mouseup", b, !0), g("keydown", b, !0), g("scroll", b, !0);
  }, []), K(() => T);
}
var T = !1, V = 0, D = 0;
function wt(t) {
  const e = t.movementX || t.screenX - V, n = t.movementY || t.screenY - D;
  return V = t.screenX, D = t.screenY, e || n || process.env.NODE_ENV === "test";
}
function Et(t) {
  wt(t) && (T = !0);
}
function b() {
  T = !1;
}
function ge(t) {
  const e = f.forwardRef((n, r) => t(p(u({}, n), { ref: r })));
  return e.displayName = t.displayName || t.name, e;
}
function me(t, e) {
  return f.memo(t, e);
}
function ye(t, e) {
  const n = e, { wrapElement: r, render: o } = n, i = Z(n, ["wrapElement", "render"]), s = Y(e.ref, at(o));
  let c;
  if (f.isValidElement(o)) {
    const d = p(u({}, o.props), { ref: s });
    c = f.cloneElement(o, ct(i, d));
  } else o ? c = o(i) : c = /* @__PURE__ */ v(t, u({}, i));
  return r ? r(c) : c;
}
function we(t) {
  const e = (n = {}) => t(n);
  return e.displayName = t.name, e;
}
function Ee(t = [], e = []) {
  const n = f.createContext(void 0), r = f.createContext(void 0), o = () => f.useContext(n), i = (a = !1) => {
    const l = f.useContext(r), E = o();
    return a ? l : l || E;
  }, s = () => {
    const a = f.useContext(r), l = o();
    if (!(a && a === l))
      return l;
  }, c = (a) => t.reduceRight(
    (l, E) => /* @__PURE__ */ v(E, p(u({}, a), { children: l })),
    /* @__PURE__ */ v(n.Provider, u({}, a))
  );
  return {
    context: n,
    scopedContext: r,
    useContext: o,
    useScopedContext: i,
    useProviderContext: s,
    ContextProvider: c,
    ScopedContextProvider: (a) => /* @__PURE__ */ v(c, p(u({}, a), { children: e.reduceRight(
      (l, E) => /* @__PURE__ */ v(E, p(u({}, a), { children: l })),
      /* @__PURE__ */ v(r.Provider, u({}, a))
    ) }))
  };
}
export {
  zt as $,
  Ot as A,
  Pt as B,
  te as C,
  ee as D,
  Lt as E,
  le as F,
  me as G,
  Gt as H,
  qt as I,
  C as J,
  It as K,
  se as L,
  _ as M,
  ie as N,
  kt as O,
  At as P,
  Ut as Q,
  re as R,
  Ft as S,
  Jt as T,
  lt as U,
  Qt as V,
  ve as W,
  x as X,
  S as Y,
  Nt as Z,
  bt as _,
  rt as a,
  jt as a0,
  Bt as a1,
  de as a2,
  pe as a3,
  Mt as a4,
  Ct as a5,
  St as a6,
  Rt as a7,
  ne as a8,
  Dt as a9,
  H as aa,
  Yt as ab,
  g as ac,
  $t as ad,
  st as ae,
  dt as af,
  Kt as ag,
  Zt as ah,
  X as b,
  Ee as c,
  Vt as d,
  mt as e,
  xt as f,
  p as g,
  u as h,
  Ht as i,
  ge as j,
  we as k,
  Z as l,
  Tt as m,
  ce as n,
  ae as o,
  Wt as p,
  K as q,
  gt as r,
  Xt as s,
  m as t,
  ue as u,
  fe as v,
  oe as w,
  Y as x,
  vt as y,
  ye as z
};
//# sourceMappingURL=7FZLUSKW.7Pws8uOI.js.map
